module.exports = __webpack_public_path__ + "assets/PackLockedIcon.b03c345967482bde646dd3bb9e8028d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/packs/PackLockedIcon.svg
// module id = 868
// module chunks = 0